import axios from "axios";
import { axiosInstance, setLoggedOut } from "./config";

// Delete the non-httpOnly presence cookie (cb_session) directly in the browser
// on every domain scope it could live under, so the marketing site at
// clipbait.ai immediately sees signed-out state. This does not depend on the
// server round-trip and beats any refresh race that might re-issue it.
function clearPresenceCookie() {
  if (typeof document === "undefined") return;
  const expired = "Thu, 01 Jan 1970 00:00:00 GMT";
  const host = window.location.hostname;
  const domains = ["", `; domain=${host}`, "; domain=.clipbait.ai"];
  domains.forEach((d) => {
    document.cookie = `cb_session=; path=/; expires=${expired}${d}; SameSite=Lax`;
  });
}



export const demoLoginCall = async (dispatch) => {
  dispatch({ type: "LOGIN_START" });
  setLoggedOut(false);
  try {
    const res = await axiosInstance.post("/auth/demo-login");
    if (res.data.token) localStorage.setItem("token", res.data.token);
    dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
  } catch (err) {
    dispatch({ type: "LOGIN_FAILURE", payload: err.response?.data?.message || "Demo login failed" });
    throw err;
  }
};

export const loginCall = async (userCredential, dispatch) => {
  dispatch({ type: "LOGIN_START" });
  setLoggedOut(false);
  try {
    const res = await axiosInstance.post("/auth/login", userCredential);
    if (res.data.token) localStorage.setItem("token", res.data.token);
    dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
  } catch (err) {
    console.error('Login error:', err);
    
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (err.response.status === 400) {
        dispatch({ type: "EMAIL_NOT_VERIFIED", payload: err.response.data.message });
      } else {
        dispatch({ type: "LOGIN_FAILURE", payload: err.response.data.message || "Login failed" });
      }
    } else if (err.request) {
      // The request was made but no response was received
      dispatch({ type: "LOGIN_FAILURE", payload: "No response from server" });
    } else {
      dispatch({ type: "LOGIN_FAILURE", payload: "Network error" });
    }
    throw err;
  }
};

export const updateCoins = async (userCredential) => {
  try {
   
    const res = await axiosInstance.put("/coins/", userCredential);
  } catch (err) {
   
  }
};

// export const premiumExpiration = async (userCredential) => {
//   try {
   
//     const res = await axiosInstance.put("/premium/", userCredential);
//   } catch (err) {
   
//   }
// };

export const premiumExpireSet = async (userCredential) => {
  try {
   
    const res = await axiosInstance.put("/premium/", userCredential);
  } catch (err) {
   
  }
};


export const logoutCall = async (dispatch) => {
  // Block the axios interceptor from silently refreshing on any 401 that
  // races with logout — otherwise it would re-issue the presence cookie.
  setLoggedOut(true);
  // Clear server-side cookies (refreshToken + cb_session presence cookie)
  // so the marketing site at clipbait.ai stops detecting the user as
  // signed in. Swallow errors — local logout should always succeed.
  try {
    await axiosInstance.post("/auth/logout");
  } catch (err) {
    console.warn("Logout endpoint failed (continuing anyway):", err?.message);
  }
  // Belt-and-suspenders: also drop the (non-httpOnly) presence cookie in the
  // browser, so the marketing nav flips to "Login / Get Clips" immediately.
  clearPresenceCookie();
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  dispatch({ type: "LOGOUT" });
};

